import appSlice from "@app/store/appSlice";
import authSlice from "@features/auth/model/authSlice";
import patientSlice from "@features/clinic-patients/model/patientSlice";
import toastSlice from "@shared/lib/toastSlice";
import topMessagesSlice from "@shared/ui/TopMessages/topMessagesSlice";
import userSlice from "@features/user/model/userSlice";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import eventSlice from "@features/events/model/eventSlice";

const rootReducer = combineReducers({
  auth: authSlice,
  user: userSlice,
  patient: patientSlice,
  app: appSlice,
  toast: toastSlice,
  topMessages: topMessagesSlice,
  event: eventSlice,
});
const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
